import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of, tap } from 'rxjs';
import { SessionService } from '@/shared/services/session.service';
import { SESSION_KEY } from '@/shared/services/session.constants';
import { environment } from '@/environment';

@Injectable({
  providedIn: 'root',
})
export class OutagesService {
  private http = inject(HttpClient);
  private sessionService = inject(SessionService);

  private baseUrl = environment?.gcp?.baseUrl;
  private outagesUrl = environment?.gcp?.outagesUrl;

  public getOutages(useCache = true): Observable<any> {
    const cachedData = this.sessionService.getData(SESSION_KEY.SERVICE_STATUS);
    if (useCache && cachedData) {
      return of(cachedData);
    } else {
      return this.http.get(`${this.baseUrl}${this.outagesUrl}`, {}).pipe(
        tap((res) => {
          this.sessionService.setData(SESSION_KEY.SERVICE_STATUS, res);
        })
      );
    }
  }

  public getPlannedOutages() {
    return this.getOutages().pipe(
      map((data) => {
        const plannedOutages = data.outages.filter((outages) => outages.outageType === 'plannedWorks');
        return plannedOutages;
      })
    );
  }
}
